import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Address } from "../contract/Address/Address";
import { AddressSearchResponse, SuggestionAddress } from "../contract/Address/AddressSearchResponse";
import { InitService } from "src/app/shared/services/init.service";
import { LookupResponse } from "../contract/Address/lookup-response";
import { ObjectInformation } from "../contract/ObjectInformation/ObjectInformation";
import { FullObjectInformationRequest } from "../contract/Address/full-object-information-request";
import { AddressesNearByRequest } from "../contract/Address/AddressesNearByRequest";
import { AddressSearchRequest } from "../contract/Address/address-search-request";

@Injectable({
  providedIn: "root"
})
export class AddressSearchApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly initService = inject(InitService);

  private readonly addressBasePath = "/api/Address";
  private readonly addressSearchWithGlobalModeUrl = `${this.addressBasePath}/GetAddressWithGlobalMode`;
  private readonly getAddressesNearByUrl = `${this.addressBasePath}/GetAddressesNearBy`;
  private readonly getAddressByIdUrl = `${this.addressBasePath}/AddressById`;
  private readonly getObjectLookupUrl = `${this.addressBasePath}/GetObjectLookup`;
  private readonly getFullObjectInformationUrl = `${this.addressBasePath}/GetFullObjectInformation`;

  getAddress(addressSearchRequest: AddressSearchRequest): Observable<AddressSearchResponse> {
    let params = new HttpParams()
      .set("searchTerm", addressSearchRequest.searchTerm)
      .set("isGlobalSearch", addressSearchRequest.isGlobalSearch);

    if (!addressSearchRequest.isGlobalSearch) {
      params = params.append("country", addressSearchRequest.country);
    }

    return this.httpClient.get<AddressSearchResponse>(this.initService.getApiUrl(this.addressSearchWithGlobalModeUrl), { params });
  }

  getAddressById(suggestionAddress: SuggestionAddress): Observable<SuggestionAddress> {
    const params = new HttpParams()
      .set("AddressID", suggestionAddress.address.addressId)
      .set("Country", suggestionAddress.address.coordinate.country)
      .set("isGlobalSearch", suggestionAddress.isGlobalSearch);

    return this.httpClient.get<SuggestionAddress>(this.initService.getApiUrl(this.getAddressByIdUrl), { params });
  }

  getAddressesNearBy(request: AddressesNearByRequest): Observable<Address[]> {
    return this.httpClient.post<Address[]>(this.initService.getApiUrl(this.getAddressesNearByUrl), request);
  }

  getLookupInfo(address: Address): Observable<LookupResponse> {
    return this.httpClient.post<LookupResponse>(this.initService.getApiUrl(this.getObjectLookupUrl), address);
  }

  getFullObjectInformation(request: FullObjectInformationRequest): Observable<ObjectInformation> {
    return this.httpClient.post<ObjectInformation>(this.initService.getApiUrl(this.getFullObjectInformationUrl), request);
  }
}
